import React from 'react';
import { X } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';

export const DiscountFormModal = ({ form, setForm, onClose, onSubmit }) => {
  const setField = (field, value) => setForm((prev) => ({ ...prev, [field]: value }));

  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4">
      <Card className="bg-purple-900 border-purple-600 max-w-md w-full">
        <CardHeader className="flex flex-row items-center justify-between">
          <CardTitle className="text-white">Create Discount Code</CardTitle>
          <Button variant="ghost" onClick={onClose} data-testid="close-discount-modal">
            <X className="w-5 h-5 text-purple-300" />
          </Button>
        </CardHeader>
        <CardContent>
          <form onSubmit={onSubmit} className="space-y-4">
            <div>
              <Label className="text-purple-200">Code</Label>
              <Input
                value={form.code}
                onChange={(e) => setField('code', e.target.value.toUpperCase())}
                placeholder="SAVE10"
                required
                className="bg-purple-800 border-purple-600 text-white"
                data-testid="discount-form-code"
              />
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label className="text-purple-200">Type</Label>
                <select
                  value={form.discount_type}
                  onChange={(e) => setField('discount_type', e.target.value)}
                  className="w-full bg-purple-800 border border-purple-600 text-white rounded-md p-2"
                >
                  <option value="percentage">Percentage (%)</option>
                  <option value="fixed">Fixed Amount ($)</option>
                </select>
              </div>
              <div>
                <Label className="text-purple-200">
                  Value {form.discount_type === 'percentage' ? '(%)' : '($)'}
                </Label>
                <Input
                  type="number"
                  step={form.discount_type === 'percentage' ? '1' : '0.01'}
                  value={form.value}
                  onChange={(e) => setField('value', e.target.value)}
                  placeholder={form.discount_type === 'percentage' ? '10' : '5.00'}
                  required
                  className="bg-purple-800 border-purple-600 text-white"
                />
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label className="text-purple-200">Min Order ($)</Label>
                <Input
                  type="number"
                  step="0.01"
                  value={form.min_order_amount}
                  onChange={(e) => setField('min_order_amount', e.target.value)}
                  placeholder="0"
                  className="bg-purple-800 border-purple-600 text-white"
                />
              </div>
              <div>
                <Label className="text-purple-200">Max Uses</Label>
                <Input
                  type="number"
                  value={form.max_uses}
                  onChange={(e) => setField('max_uses', e.target.value)}
                  placeholder="Unlimited"
                  className="bg-purple-800 border-purple-600 text-white"
                />
              </div>
            </div>
            <div>
              <Label className="text-purple-200">Expires</Label>
              <Input
                type="date"
                value={form.expires_at}
                onChange={(e) => setField('expires_at', e.target.value)}
                className="bg-purple-800 border-purple-600 text-white"
              />
            </div>
            <Button
              type="submit"
              className="w-full bg-yellow-500 hover:bg-yellow-600 text-purple-900"
              data-testid="submit-discount-btn"
            >
              Create Discount
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};
